import React from 'react';

import { Checkbox, type CheckboxProps } from '@atlaskit/checkbox';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';

const containerStyles = xcss({
	paddingLeft: 'space.100',
	paddingRight: 'space.150',
	paddingTop: 'space.050',
	paddingBottom: 'space.050',
	boxSizing: 'border-box',
	borderRadius: 'radius.small',
	maxWidth: '280px', // matches filter button
});

const backgroundStyles = xcss({
	backgroundColor: 'color.background.neutral',
});

const containerCheckedStyles = xcss({
	backgroundColor: 'color.background.selected',
});

const labelStyles = xcss({
	fontWeight: 'font.weight.medium',
});

const labelActiveStyle = xcss({
	color: 'color.text.selected',
});

interface ToggleFilterProps {
	autoFocus: boolean;
	children: string;
	isChecked: boolean;
	isFilterInDropdown?: boolean;
	onChange: CheckboxProps['onChange'];
}

export const ToggleFilter = ({
	children,
	onChange,
	isChecked,
	autoFocus = false,
	isFilterInDropdown = false,
}: ToggleFilterProps): React.JSX.Element => {
	return (
		<Box
			xcss={[
				containerStyles,
				...(!isFilterInDropdown ? [backgroundStyles, isChecked && containerCheckedStyles] : []),
			]}
		>
			<Checkbox
				label={<Box xcss={[labelStyles, isChecked && labelActiveStyle]}>{children}</Box>}
				onChange={onChange}
				isChecked={isChecked}
				autoFocus={autoFocus}
			/>
		</Box>
	);
};
